module.exports = __webpack_public_path__ + "static/media/about_us.dc0677d3.png";